/**
 * Project : workspace
 * File    : MyBusinessStoreScreen.kt
 * Created : AUTO-GENERATED by scripts/add_kdoc.py
 */

package presentation.screens.business.store

import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.lazy.LazyColumn
import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.collectAsState
import androidx.compose.ui.Modifier
import androidx.compose.ui.unit.dp
import com.friendly.shared.component.layout.VerticalGrid
import com.parmartechnologies.business.feature.business.viewModel.BusinessViewModel
import com.parmartechnologies.business.feature.businessConfig.viewModel.BusinessConfigViewModel
import common.constants.StoreMenuConfig
import component.navigation.TopNavBar
import locale.localization
import navigation.AppNavigator
import presentation.screens.business.home.component.headerCard
import presentation.screens.business.store.component.StoreMenuCard

/**
 * Represents the my business store screen class.
 */

class MyBusinessStoreScreen{
    val params = AppNavigator.shared().getNavigationParam()
    @Composable
    /**
 * Executes the content operation.
 *
 * @receiver TODO
 * @return Unit – no return value.
 */
    fun Content() {
        val businessViewModel = BusinessViewModel()
        val viewModel = BusinessConfigViewModel()
        val businessConfig = viewModel.businessConfig.collectAsState()
        val allMenu = StoreMenuConfig().getMenu()
        val myBusiness = businessViewModel.myBusiness.collectAsState()
        LaunchedEffect(key1 = Unit) {
            params.business = myBusiness.value
            params.business = myBusiness.value
            params.selectedBusiness = myBusiness.value
            viewModel.fetchBusinessConfig()
            if (businessConfig.value?._id?.isEmpty() == true) {
                viewModel.fetchBusinessConfig()
            } else {
                viewModel.editBusinessConfig(businessConfig.value)
            }
        }
        Column {
            TopNavBar(
                localization().storeMenu.storeTitle, AppNavigator.shared().getNavigationParam(), onBackPress = {
                    AppNavigator.shared().goBack()
                }
            )
            LazyColumn(
                modifier = Modifier
                    .fillMaxSize().padding(bottom = 8.dp)
            ) {
                item {
                    headerCard(menu = allMenu[0])
                    VerticalGrid(
                        columns = 2
                    ) {
                        allMenu[0].sub_menu.forEach { menu ->
                            StoreMenuCard(menu, businessConfig.value) { screen ->

                                AppNavigator.shared().navigate(screen ?: "",params)
                            }
                        }
                    }
                    headerCard(menu = allMenu[1])
                    VerticalGrid(
                        columns = 2
                    ) {
                        allMenu[1].sub_menu.forEach { menu ->
                            StoreMenuCard(menu, businessConfig.value) { screen ->
                                AppNavigator.shared().navigate(screen ?: "",params)
                            }
                        }
                    }
                    headerCard(menu = allMenu[2])
                    VerticalGrid(
                        columns = 2
                    ) {
                        allMenu[2].sub_menu.forEach { menu ->
                            StoreMenuCard(menu, businessConfig.value) { screen ->
                                AppNavigator.shared().navigate(screen ?: "")
                            }
                        }
                    }
                    headerCard(menu = allMenu[3])
                    VerticalGrid(
                        columns = 2
                    ) {
                        allMenu[3].sub_menu.forEach { menu ->
                            StoreMenuCard(menu, businessConfig.value) { screen ->
                                AppNavigator.shared().navigate(screen ?: "")
                            }
                        }
                    }
                }
            }
        }

    }
}